import { render, staticRenderFns } from "./ImageAnnotator.vue?vue&type=template&id=2fef0186&scoped=true"
import script from "./ImageAnnotator.vue?vue&type=script&lang=js"
export * from "./ImageAnnotator.vue?vue&type=script&lang=js"
import style0 from "./ImageAnnotator.vue?vue&type=style&index=0&id=2fef0186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef0186",
  null
  
)

export default component.exports